import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setDataToSend } from "redux/actions/invoices/invoicesCashAction"

export const useCommentsHook = ({
  values, validate, reset
}) => {
  const dispatch = useDispatch()
  const { readyToSend, clearForm } = useSelector(({ cashInvoices }) => cashInvoices)

  const saveData = () => {
    const observations = {
      observations: values.comment
    }
    dispatch(setDataToSend('comments', observations))
  }

  useEffect(() => {
    readyToSend && validate([], saveData)
  }, [readyToSend])

  useEffect(() => {
    if (clearForm) {
      reset()
    }
  }, [clearForm])
}